export interface JobDef {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export const JOBS: Record<string, JobDef> = {
  frontend_mage: {
    id: "frontend_mage",
    name: "프론트엔드 법사",
    icon: "⚡",
    desc: "CSS 마법과 컴포넌트 주문으로 화면을 빚어내는 직업. 픽셀 하나까지 정렬하는 집념으로 적을 제압한다.",
  },
  vibe_coder: {
    id: "vibe_coder",
    name: "바이브코더",
    icon: "🎵",
    desc: "느낌과 바이브로 코드를 흐르게 하는 직업. 일단 돌아가면 그게 정답. AI와 춤추듯 개발하며 빠르게 성장한다.",
  },
};

export type JobId = keyof typeof JOBS;

export function isValidJob(job: unknown): job is string {
  return typeof job === "string" && job in JOBS;
}

// nickname: 2~12 chars, 한글/영문/숫자만
const NICK_RE = /^[가-힣a-zA-Z0-9]{2,12}$/;
export function isValidNickname(nick: unknown): nick is string {
  return typeof nick === "string" && NICK_RE.test(nick);
}
